import React, { useEffect, useRef, useState } from 'react'
import Logo from "../images/ygLogoMailSignature.png"
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import axios from 'axios';
import { ConfigProvider, Pagination } from "antd";
import CustomSpinner from '../components/CustomSpinner';
import { Modal } from "react-bootstrap";
import dayjs from 'dayjs';
import { v4 } from 'uuid';


import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import DateRangeIcon from '@mui/icons-material/DateRange';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import SchoolIcon from '@mui/icons-material/School';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

import ReferBackground from "../images/referEarnBackground.jpg"

function Refer({ serverURL }) {

    const nameToOTPRef = useRef("")
    const emailToOTPRef = useRef("")
    const [otpStages, setOTPStages] = useState(1)
    const otpRef = useRef(null)

    const [showSuccessMessage, setShowSuccessMessage] = useState(false)

    const [loadingEntries, setLoadingEntries] = useState(true);

    const [globalEmail, setGlobalEmail] = useState(null)
    const [globalName, setGlobalName] = useState(null)


    const [currentPageNumber, setCurrentPageNumber] = useState(1)

    const [entriesLimit, setEntriesLimit] = useState(100)
    const [skipEntries, setSkipEntries] = useState(0)
    const [totalEntriesCount, setTotalEntriesCount] = useState(0)

    const [loggedInUser, setLoggedInUser] = useState(false)

    const nameRef = useRef("")
    const EmailAddref = useRef("")
    const PhoneRef = useRef("")
    const LocationRef = useRef("")
    const InterestedCourseRef = useRef("")


    const [allReferrals, setAllReferrals] = useState([])
    const [loadingButton, setLoadingButton] = useState(false)

    const [otp, setOtp] = useState(null)


    const handleOTPStep2 = async (e) => {
        e.preventDefault()
        const fields = document.getElementsByClassName("inputFocusField")

        let stringOTP = `${fields[0].value}${fields[1].value}${fields[2].value}${fields[3].value}`
        if (stringOTP === otp) {
            // alert("Verified")
            const createCookie = await axios.get(serverURL + "/referal/setTemporaryCookie/" + globalEmail + "/" + globalName, { withCredentials: true })
            if (createCookie.status === 200) {
                setOTPStages(3)
                setLoadingEntries(true)
                e.target.reset()
            } else {
                console.log(createCookie.data)
            }
        } else {
            alert("Wrong OTP")
        }

    }

    const getCookies = async () => {
        const getNow = await axios.get(serverURL + "/referal/getCookieUser", { withCredentials: true })
        if (getNow.status === 200) {
            if (getNow.data.user) {
                setOTPStages(3)
                setGlobalEmail(getNow.data.user)
                setGlobalName(getNow.data.name)
            }
            setLoadingEntries(true)
            // console.log(getNow.data)
        } else {
            console.log(getNow.data)
        }
    }

    const getAllRecords = async () => {
        const query = {
            "skip": skipEntries,
            "limit": entriesLimit
        }
        const getNow = await axios.post(serverURL + "/referal/getAll", query)
        if (getNow.status === 200) {
            // console.log(getNow.data)
            setAllReferrals(getNow.data.records.filter((ref => { return ref.ReferrerMail?.email === globalEmail })))
            setTotalEntriesCount(getNow.data.total)
        } else {
            console.log(getNow.data)
        }
    }

    const saveRecordNow = async (e) => {
        e.preventDefault()
        const query = {
            ReferrerMail: { email: globalEmail, name: globalName },
            Date: new Date(),
            Name: nameRef.current.value,
            Email: EmailAddref.current.value,
            Mobile: PhoneRef.current.value,
            Location: LocationRef.current.value,
            Course: InterestedCourseRef.current.value,
            Eligibility: "",
            Process: "",
            Reward: "",
        }
        const saveThisNow = await axios.post(serverURL + "/referal/saveNow", query)
        if (saveThisNow.status === 200) {
            console.log(saveThisNow.data)
            setAllReferrals([...allReferrals, saveThisNow.data])
            e.target.reset()
            setShowSuccessMessage(true)
        } else {
            console.log(saveThisNow.data)
        }
    }

    const handleOTPStep1 = async (e) => {
        e.preventDefault()
        setGlobalName(nameToOTPRef.current.value)
        setGlobalEmail(emailToOTPRef.current.value)
        setLoadingButton(true)
        const query = {
            email: emailToOTPRef.current.value,
            name: nameToOTPRef.current.value
        }

        const general = await axios.post(serverURL + "/referal/sendOTP", query)
        if (general.status === 200) {
            console.log(general.data)
            setOtp(general.data.otp)
            setOTPStages(2)
            setLoadingButton(false)

            e.target.reset()
        } else {
            console.log(general.data)
            setLoadingButton(false)
        }
    }
    useEffect(() => {
        getAllRecords()
    }, [entriesLimit, skipEntries, globalEmail])

    useEffect(() => {
        getCookies()
    }, [])


    const changeFocus = async (e, number) => {
        console.log(e.nativeEvent.data)
        const fields = document.getElementsByClassName("inputFocusField")


        fields[number].value = e.nativeEvent.data

        if (number < fields.length - 1) {
            fields[number + 1].focus()
        }

    }


    return (
        <>
            {
                loadingEntries ?
                    <div className='vh-100 vw-100 d-flex flex-column justify-content-start align-items-center p-0 m-0 overflow-auto'>

                        <div className='w-100 d-flex justify-content-between align-items-center shadow-sm px-3 sticky-top'>
                            <div>
                                {Logo && <img src={Logo} alt="Logo" className='img-fluid' style={{ maxWidth: "120px" }} onClick={() => window.open("https://www.yesgermany.com", "_blank")} />}
                            </div>
                            <div className='d-flex gap-3 justify-content-end align-items-center'>
                                <a href="mailto:studentsuccess@yesgermany.com" target="_blank" title='Mail Us' rel="noopener noreferrer" className='text-decoration-none text-dark'>
                                    <MailOutlineIcon />
                                </a>
                                <a href="https://www.yesgermany.org/studentsupport" target="_blank" title='Raise a Query' rel="noopener noreferrer" className='text-decoration-none text-dark'>
                                    <HelpOutlineIcon />
                                </a>
                            </div>
                        </div>


                        <div className='w-100 d-flex justify-content-center p-3 flex-wrap customLayoutPrinting'>
                            <div className='referBackround rounded-5 overflow-hidden d-flex align-items-center'>
                                <img src={ReferBackground} className='w-100' style={{ maxWidth: "700px" }} alt="" />
                            </div>
                            <div className='w-100 d-flex flex-column justify-content-start align-items-center p-4 rounded-5 shadow-sm' style={{ background: "#ffce00", maxWidth: "500px" }}>

                                <h1 className='display-6 text-light fw-bold text-start w-100' style={{ textShadow: "0 0 2px rgba(0,0,0,0.5)" }}>Earn upto <span className='text-danger'>₹10,000</span> per referral *</h1>
                                <p style={{ fontWeight: "500" }} className='mt-3 w-100 text-start w-100 pb-3'>Help your friends study in Germany and enjoy exclusive rewards for every successful enrollment!</p>
                                {
                                    otpStages === 1 ?
                                        <form action="" onSubmit={(e) => { handleOTPStep1(e) }} className='w-100 d-flex flex-column justify-content-center align-items-center gap-3 p-3 shadow bg-light rounded-4'>
                                            <h5>Great Connections Starts With You</h5>
                                            <input type="text" required ref={nameToOTPRef} placeholder='Enter your Name' className='form-control' />
                                            <input type="email" required ref={emailToOTPRef} placeholder='Enter your email' className='form-control' />
                                            <button type='submit' className={`btn btn-sm ${loadingButton ? "btn-light" : "btn-dark"} rounded w-100 d-flex align-items-center justify-content-center`} style={{ maxWidth: "120px" }}>
                                                {
                                                    loadingButton ?
                                                        <CustomSpinner size={.3} />
                                                        :
                                                        "Start Earning"

                                                }
                                            </button>
                                        </form>
                                        :
                                        otpStages === 2 ?
                                            <form action="" onSubmit={(e) => { handleOTPStep2(e) }} className='w-100 d-flex flex-column justify-content-center align-items-center gap-3 rounded-3'>
                                                <input type="hidden" required ref={otpRef} placeholder='Enter the OTP' className='form-control' />
                                                <div className='d-flex w-100 gap-3 justify-content-around px-4'>
                                                    <input type='text' maxLength={1} onInput={(e) => { changeFocus(e, 0) }} className='inputFocusField border-0 text-center fw-bold fs-1 rounded bg-light' style={{ outline: "none", width: "100%", aspectRatio: "1" }} />
                                                    <input type='text' maxLength={1} onInput={(e) => { changeFocus(e, 1) }} className='inputFocusField border-0 text-center fw-bold fs-1 rounded bg-light' style={{ outline: "none", width: "100%", aspectRatio: "1" }} />
                                                    <input type='text' maxLength={1} onInput={(e) => { changeFocus(e, 2) }} className='inputFocusField border-0 text-center fw-bold fs-1 rounded bg-light' style={{ outline: "none", width: "100%", aspectRatio: "1" }} />
                                                    <input type='text' maxLength={1} onInput={(e) => { changeFocus(e, 3) }} className='inputFocusField border-0 text-center fw-bold fs-1 rounded bg-light' style={{ outline: "none", width: "100%", aspectRatio: "1" }} />
                                                </div>
                                                <button type='submit' className='btn btn-md btn-dark rounded w-100'>Verify</button>
                                            </form>
                                            :
                                            otpStages === 3 ?
                                                <form action="" onSubmit={(e) => { saveRecordNow(e); }} style={{ background: "white" }} className='w-100 d-flex flex-column justify-content-center align-items-center gap-3 p-3 shadow rounded-4'>
                                                    <span className='fw-bold h5'>Welcom {globalName}</span>
                                                    <hr style={{ color: "#ffce00", border: "1px solid #ffce00" }} className='w-100 m-0' />
                                                    <span className='fw-bold h5'>Submit Referral Details</span>
                                                    <input type="text" required ref={nameRef} placeholder='Full Name' className='form-control' />
                                                    <input type="text" required ref={EmailAddref} placeholder='Email Address' className='form-control' />
                                                    <input type="text" required ref={PhoneRef} placeholder='Phone Number' className='form-control' />
                                                    <input type="text" required ref={LocationRef} placeholder='Location' className='form-control' />
                                                    <textarea required ref={InterestedCourseRef} placeholder='Interested Course/Program' className='form-control' />
                                                    <button type='submit' className='btn btn-sm btn-dark rounded w-100' style={{ maxWidth: "120px" }}>Save</button>
                                                </form>
                                                :
                                                ""
                                }
                            </div>
                        </div>



                        {
                            otpStages != 3 ?
                                <>

                                    <div className='p-4 w-100' style={{ maxWidth: "700px" }}>
                                        <p className='fs-4 fw-bold text-start mt-5'>How does it work</p>

                                        <div className='d-flex flex-column justify-content-center align-items-start pointerDotterLines gap-3'>
                                            <div className='dotSections d-flex flex-column justify-content-center align-items-start shadow-sm p-2 rounded w-100' style={{ background: "#f8f9fa" }}>
                                                <h6 className='m-0' style={{ fontWeight: "600" }}>Login</h6>
                                                <p className='m-0'>Login Enter your email & OTP to access your dashboard.</p>
                                            </div>

                                            <div className='dotSections d-flex flex-column justify-content-center align-items-start shadow-sm p-2 rounded w-100' style={{ background: "#f8f9fa" }}>
                                                <h6 className='m-0' style={{ fontWeight: "600" }}>Submit Referral Details</h6>
                                                <p className='m-0'>Please submit your referral’s name, email, phone number, and course interest.</p>
                                            </div>

                                            <div className='dotSections d-flex flex-column justify-content-center align-items-start shadow-sm p-2 rounded w-100' style={{ background: "#f8f9fa" }}>
                                                <h6 className='m-0' style={{ fontWeight: "600" }}>Reward Eligibility</h6>
                                                <p className='m-0'>Eligibility is shown once your referral qualifies based on the Eligibility Critaria.</p>
                                            </div>

                                            <div className='dotSections d-flex flex-column justify-content-center align-items-start shadow-sm p-2 rounded w-100' style={{ background: "#f8f9fa" }}>
                                                <h6 className='m-0' style={{ fontWeight: "600" }}>Track Registration Status</h6>
                                                <p className='m-0'>Monitor referral progress in real-time through your dashboard.</p>
                                            </div>
                                            <div className='dotSections d-flex flex-column justify-content-center align-items-start shadow-sm p-2 rounded w-100' style={{ background: "#f8f9fa" }}>
                                                <h6 className='m-0' style={{ fontWeight: "600" }}>Earn Rewards</h6>
                                                <p className='m-0'>Get rewarded once your referral completes their process</p>
                                            </div>
                                        </div>

                                    </div>
                                    <div style={{ background: "#ffce00" }} className='w-100 d-flex flex-column justify-content-center align-items-center mt-3 '>
                                        <div className='w-100 p-4' style={{ maxWidth: "700px" }}>
                                            <p className='fs-4 fw-bold text-start'>Eligibility Criteria:</p>
                                            <ul className='m-0 mt-3 ' style={{ paddingLeft: "22px" }}>
                                                <li>Referred student must be new (not in our system).</li>
                                                <li>Self-referrals not allowed.</li>
                                                <li>Rewards apply only after student completes their process.</li>
                                            </ul>
                                        </div>

                                    </div>
                                </>
                                :
                                <div className='w-100 h-100'>
                                    <div className='w-100 h-100  bg-light p-3'>
                                        <div className='w-100 h-100 overflow-auto'>
                                            <h4 className='mb-3'>My Referrals</h4>

                                            <div className='d-flex w-100 flex-wrap gap-3'>
                                                {
                                                    allReferrals ?
                                                        allReferrals.length > 0 ?
                                                            allReferrals.map((ref, key) => {
                                                                return (
                                                                    <div className='d-flex flex-column gap-1 alert alert-light rounded-3 w-100 shadow-sm' style={{ maxWidth: "350px", backgroundImage: "linear-gradient(-45deg, #ffffff,rgba(255, 204, 0, 0.1))" }} key={key}>
                                                                        <span className='fw-bold text-capitalize text-dark' style={{ fontSize: "20px" }}>{ref.Name}</span>
                                                                        <hr className='m-0' style={{ color: "rgba(0,0,0,0.6)" }} />
                                                                        <span className='d-flex align-items-center gap-2'><PhoneEnabledIcon />{ref.Mobile}</span>
                                                                        <span className='d-flex align-items-center gap-2'><AlternateEmailIcon />{ref.Email}</span>
                                                                        <span className='d-flex align-items-center gap-2'><SchoolIcon />{ref.Course}</span>
                                                                        {/* 
                                                                        <span className='d-flex align-items-center gap-2'><WorkspacePremiumIcon />{ref.Eligibility}</span>
                                                                        <span className='d-flex align-items-center gap-2'><AccountTreeIcon />{ref.Process}</span>
                                                                        <span className='d-flex align-items-center gap-2'><CardGiftcardIcon />{ref.Reward}</span> */}
                                                                        <div className='d-flex align-items-center justify-content-end text-muted gap-2 text-end w-100' style={{ fontSize: "13px" }}>
                                                                            {/* <DateRangeIcon /> */}
                                                                            {dayjs(ref.Date).format("D MMM YYYY")}
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                            :
                                                            <div className="alert alert-secondary shadow-sm text-center w-100">
                                                                <span className='fw-bold text-dark d-block fs-6'>No Referrals Yet!</span>
                                                            </div>
                                                        :
                                                        <div className="alert alert-secondary shadow-sm text-center w-100">
                                                            <span className='fw-bold text-dark d-block fs-6'>No Referrals Yet!</span>
                                                        </div>
                                                }
                                            </div>
                                        </div>

                                    </div>

                                </div>
                        }



                        <div className='w-100 d-flex justify-content-end align-items-center p-3'>
                            <a href="https://www.instagram.com/yesgermany_official/"
                                target="_blank" style={{ color: "#393e46" }}>
                                <img src="https://yesgermany.org/instagramLogo.png" alt="" style={{ height: "20px", padding: "0 5px" }} />
                            </a>

                            <a href="https://www.facebook.com/yesgermany" target="_blank"
                                style={{ color: "#ffffff" }}>
                                <img src="https://yesgermany.org/facebookLogo.png" alt="" style={{ height: "20px", padding: "0 5px" }} />
                            </a>

                            <a href="https://www.linkedin.com/company/yes-germany2/"
                                target="_blank" style={{ color: "#ffffff" }}>
                                <img src="https://yesgermany.org/linkedIn.png" alt="" style={{ height: "20px", padding: "0 5px" }} />
                            </a>

                            <a href="https://www.youtube.com/@yesgermany"
                                target="_blank" style={{ color: "#ffffff" }}>
                                <img src='https://yesgermany.org/youtubeLogo.png' alt="" style={{ height: "20px", padding: "0 5px" }} />
                            </a>
                        </div>
                    </div>
                    :
                    <div className='w-100 vh-100 d-flex align-items-center justify-content-center'>
                        <CustomSpinner size={1} />
                    </div>
            }


            <Modal
                show={showSuccessMessage}
                centered
                size='md'
                onHide={() => { setShowSuccessMessage(false) }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Referral Submitted!</Modal.Title>
                </Modal.Header>
                <Modal.Body className='p-0'>
                    <div className="alert alert-success px-3 py-5 text-center m-0 rounded-0 border-0">
                        You have successfully submitted the referral.
                    </div>
                </Modal.Body>
                <Modal.Footer className='d-flex justify-content-center'>
                    <button className='btn btn-sm btn-dark rounded px-4' onClick={() => { setShowSuccessMessage(false) }}>OK</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Refer